import { View, Text } from "react-native";
import React from "react";
import { Ionicons } from "@expo/vector-icons";

export default function FooterloginComponent() {
  return (
    <View className="absolute bottom-0 w-full z-10">
      <View className="px-6 py-3 border-t border-gray-300  items-center rounded-t-3xl">
        <Text className="text-center text-gray-700 text-sm font-kanit flex-row items-center justify-center">
          Made with{" "}
          <Ionicons
            name="heart"
            size={14}
            color="#F17736"
            style={{ marginBottom: -2 }}
          />{" "}
          by{" "}
          <Text className="text-[#F17736] underline decoration-wavy">
            Digital Transformation Teams
          </Text>
        </Text>

        {/* <Text className="text-center text-gray-700 text-sm font-kanit">
          © 2025 All rights reserved.
        </Text> */}

        <Text className="text-[12px] text-gray-500 text-center font-kanit leading-relaxed mt-1">
          “ในโลกของดิจิทัล ความคิดสร้างสรรค์คือพลังที่เปลี่ยนแปลงทุกอย่าง”
        </Text>
      </View>
    </View>
  );
}
